var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,0H7A5.006,5.006,0,0,0,2,5v9a5.008,5.008,0,0,0,4.266,4.946L4.143,22.485a1,1,0,0,0,1.714,1.03L8.566,19h6.868l2.709,4.515a1,1,0,0,0,1.714-1.03l-2.123-3.539A5.008,5.008,0,0,0,22,14V5A5.006,5.006,0,0,0,17,0ZM13,11V6h7v5ZM4,11V6h7v5ZM7,2H17a3,3,0,0,1,2.828,2H4.172A3,3,0,0,1,7,2ZM17,17H7a3,3,0,0,1-3-3V13H6v1a1,1,0,0,0,2,0V13h8v1a1,1,0,0,0,2,0V13h2v1A3,3,0,0,1,17,17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubway);
export default __webpack_public_path__ + "static/media/subway.d3889a53a0453296b31c9915eb0d267a.svg";
export { ForwardRef as ReactComponent };